var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavbarMarketingActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.805 16.598c.205.41.067.902-.305 1.15l-.098.057-10 5c-.217.109-.467.124-.694.047l-.11-.047-10-5c-.445-.222-.625-.763-.403-1.207.205-.41.681-.596 1.103-.447l.104.044 9.598 4.8 9.597-4.8c.445-.222.985-.042 1.208.403zm0-5c.205.41.067.902-.305 1.15l-.098.057-10 5c-.217.109-.467.124-.694.047l-.11-.047-10-5c-.445-.222-.625-.763-.403-1.207.205-.41.681-.596 1.103-.447l.104.044 9.598 4.8 9.597-4.8c.445-.222.985-.042 1.208.403zM11.597 1.195c.254-.127.552-.127.805 0l10 5c.664.332.664 1.278 0 1.61l-10 5c-.253.127-.551.127-.805 0l-10-5c-.663-.332-.663-1.278 0-1.61l10-5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarMarketingActive);
export default __webpack_public_path__ + "static/media/navbar_marketing_active.b21f07d1b7ba3a4fa61f4a39af42d10d.svg";
export { ForwardRef as ReactComponent };